import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '../__partials/avatar';
import { marginClassNamePropType } from '../../__utils/spacingClassNamePropType';

const AvatarGroup = ({
  size,
  groupCount,
  primaryColor,
  secondaryColor,
  showOuterBorder,
  onMouseEnter,
  onMouseLeave,
  onClick,
  className,
  qaId,
}) => {
  return (
    <Avatar
      type="group"
      size={size}
      text={groupCount}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      showOuterBorder={showOuterBorder}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      className={className}
      qaId={qaId}
    />
  );
};

AvatarGroup.propTypes = {
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'profile']),
  groupCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  showOuterBorder: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  className: marginClassNamePropType,
  qaId: PropTypes.string,
};

AvatarGroup.defaultProps = {
  size: 'medium',
  className: '',
};

export default AvatarGroup;



// WEBPACK FOOTER //
// ./src/avatars/group/index.jsx